import { EventsRegistry } from "./events";
import { registerEvent, triggerEvent } from "./events/bus";
import { parseCSV, buildTableUnitFromCSV } from "./events/csvHelpers";

export const initEngineEvents = () => {
  // ─────────────────────────────────────────────
  // FILE DROPPED → PARSE → VALIDATE → FAN OUT
  // ─────────────────────────────────────────────
  registerEvent(EventsRegistry.FILE_DROPPED, async ({ file }) => {
    try {
      if (!file?.name?.endsWith(".csv")) {
        triggerEvent(EventsRegistry.NOTIFY, {
          type: "error",
          message: "Only CSV files are supported",
        });
        return;
      }

      const parsed = await parseCSV(file);

      if (!parsed?.rows?.length || !parsed?.headers?.length) {
        triggerEvent(EventsRegistry.NOTIFY, {
          type: "error",
          message: "CSV file is empty or malformed",
        });
        return;
      }

      triggerEvent(EventsRegistry.FILE_VALIDATED, {
        payload: parsed,
        meta: {
          rows: parsed.rows.length,
          cols: parsed.headers.length,
          filename: file.name,
        },
      });
    } catch (err) {
      console.error("CSV parse failed:", err);
      triggerEvent(EventsRegistry.NOTIFY, {
        type: "error",
        message: "Failed to parse CSV file",
      });
    }
  });

  // ─────────────────────────────────────────────
  // FILE_VALIDATED → CSV_UPLOADED
  // ─────────────────────────────────────────────
  registerEvent(EventsRegistry.FILE_VALIDATED, ({ payload, meta }) => {
    triggerEvent(EventsRegistry.CSV_UPLOADED, { payload, meta });

    triggerEvent(EventsRegistry.NOTIFY, {
      type: "success",
      message: `CSV uploaded: ${meta.rows} rows, ${meta.cols} columns`,
    });
  });


  // ─────────────────────────────────────────────
  // TABLE_ROW_COMMITTED → UPDATE CONTEXT
  // ─────────────────────────────────────────────
registerEvent(
  EventsRegistry.TABLE_ROW_COMMITTED,
  ({ unitId, rowId, rowData }, { getContext, updateContext }) => {
    const ctx = getContext();
    if (!ctx) return;

    const nextUnits = ctx.context_units.map(unit => {
      if (unit.id !== unitId) return unit;

      // Update the dictionary inside the data array
      const nextData = unit.data.map(item => {
        // Find the specific object by its top-level row_id
        if (item.row_id === rowId) {
          return { 
            ...item, 
            row: { ...rowData } // Update the nested row dictionary
          };
        }
        return item;
      });

      return { ...unit, data: nextData };
    });

    // Update the Global Context
    updateContext("context_units", nextUnits);

    // 🔔 Trigger CONTEXT_UPDATED for other subscribers (like SVG map)
    triggerEvent(EventsRegistry.CONTEXT_UPDATED, { context: getContext() });

    // Notify the user
    triggerEvent(EventsRegistry.NOTIFY, {
      type: "info",
      message: `Row committed: ${rowId}`, 
    });
  }
);



  // ─────────────────────────────────────────────
  // NOTIFY (centralized)
  // ─────────────────────────────────────────────
  registerEvent(EventsRegistry.NOTIFY, ({ message, type = "info" }) => {
    console.log(`[${type.toUpperCase()}]`, message);
  });
};
